<template>
  <div class="wrapper">
    <!-- v-loading.fullscreen="loading" -->
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamelist' }">{{ "竞技赛事" }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamedetail' }">{{ "赛事详情" }}</router-link>
          <span>></span>
          <span>{{ "排位赛" }}</span>
        </div>
      </div>
    </div>
    <div class="main bgw" style="background-color: rgba(250, 250, 250, 1)">
      <div class="shop-container">
        <div class="tabs">
          <el-select v-model="select1" placeholder="请选择" @change="changeSelect1($event)">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
            </el-option>
          </el-select>
          <el-select v-model="select2" placeholder="请选择" @change="changeSelect2($event)">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
            </el-option>
          </el-select>
        </div>
        <div style="margin-bottom: 20px">
          <el-table
            v-if="select2 == 1"
            :data="tableData"
            height="500"
            border
            style="width: 100%"
            ref="singleTable"
            highlight-current-row
            @current-change="handleCurrentChange"
          >
            <el-table-column prop="return[num]" label="名次" width="100"> </el-table-column>
            <el-table-column prop="return[target_num3]" label="靶号" width="100"> </el-table-column>
            <el-table-column prop="return[nickname]" label="姓名"> </el-table-column>
            <el-table-column prop="return[ten_ring_num]" label="10's"> </el-table-column>
            <el-table-column prop="return[x_ring_num]" label="X's"> </el-table-column>
            <el-table-column prop="return[total]" label="总成绩"> </el-table-column>
            <el-table-column :label="`${distance_num}` + 'm'" v-if="options2.length == 1"> 小分</el-table-column>
          </el-table>
          <el-table
            v-else
            :data="tableData"
            height="500"
            border
            style="width: 100%"
            ref="singleTable"
            highlight-current-row
            @current-change="handleCurrentChange"
          >
            <el-table-column prop="return[num]" label="名次" width="100"> </el-table-column>
            <el-table-column prop="return[target_num3]" label="靶号" width="100"> </el-table-column>
            <el-table-column prop="return[nickname]" label="姓名"> </el-table-column>
            <el-table-column prop="return[ten_ring_num]" label="10's"> </el-table-column>
            <el-table-column prop="return[x_ring_num]" label="X's"> </el-table-column>
            <el-table-column prop="return[total]" label="本轮成绩"> </el-table-column>
            <el-table-column :label="`${distance_num}` + 'm'"> 小分</el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="showDescript" width="50%" :before-close="handleClose">
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column">
        <el-table :data="tableDataDetail" border style="width: 100%">
          <el-table-column type="index" label="组数" width="100"> </el-table-column>
          <el-table-column label="每箭环数">
            <template slot-scope="scope">
              <span class="small_default_btn" v-show="scope.row.result[1]">{{ scope.row.result[1] }}</span>
              <span class="small_default_btn" v-show="scope.row.result[2]">{{ scope.row.result[2] }}</span>
              <span class="small_default_btn" v-show="scope.row.result[3]">{{ scope.row.result[3] }}</span>
              <span class="small_default_btn" v-show="scope.row.result[4]">{{ scope.row.result[4] }}</span>
              <span class="small_default_btn" v-show="scope.row.result[5]">{{ scope.row.result[5] }}</span>
              <span class="small_default_btn" v-show="scope.row.result[6]">{{ scope.row.result[6] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="小分">
            <template slot-scope="scope">
              <span class="small_default_btn">{{ grades([scope.row.result[1], scope.row.result[2], scope.row.result[3]]) }}</span>
              <span class="small_default_btn">{{ grades([scope.row.result[4], scope.row.result[5], scope.row.result[6]]) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="组分">
            <template slot-scope="scope">{{
              grades([scope.row.result[1], scope.row.result[2], scope.row.result[3], scope.row.result[4], scope.row.result[5], scope.row.result[6]])
            }}</template>
          </el-table-column>
          <el-table-column prop="result_total" label="总分"> </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameId: "game",
      select1: "",
      select2: "",
      options1: [],
      options2: [
        {
          label: "总成绩",
          value: 1,
        },
        {
          label: "第一轮",
          value: 2,
        },
        {
          label: "第二轮",
          value: 3,
        },
        {
          label: "第三轮",
          value: 4,
        },
        {
          label: "第四轮",
          value: 5,
        },
      ],
      tableData: [],
      getData: [],
      distance_num: "",
      currentRow: "",
      showDescript: false,
      dialogTitle: "",
      tableDataDetail: [],
    };
  },
  mounted() {
    this.gameId = this.$route.params.gameId;
    this.startClass();
  },
  computed: {
    grades(arr) {
      return (arr) => {
        let num = 0;
        arr.forEach((e) => {
          if (e == "X") {
            num += 10;
          } else if (e == "M" || e == "" || e == null || e == undefined) {
            num += 0;
          } else {
            num += e * 1;
          }
        });
        return num;
      };
    },
  },
  methods: {
    handleClose() {
      this.setCurrent();
      this.showDescript = false;
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(val) {
      if ((this.select2 == 1 && this.options2.length == 1) || (this.select2 != 1 && this.options2.length > 1)) {
        this.currentRow = val;
        console.log(val);
        this.tableDataDetail = [];
        if (val.return) {
          this.dialogTitle = this.currentRow.return.nickname;
          let params = JSON.parse(val.return.params);
          if (params) {
            if (Object.keys(params) && Object.keys(params).length > 0) {
              let allNumer = 0;
              Object.keys(params).forEach((e, i) => {
                let newObj = { ...params[e] };
                allNumer += newObj.result_total * 1;
                newObj.result_total = allNumer;
                this.tableDataDetail.push(newObj);
              });
            }
            // console.log(this.tableDataDetail);
          }
        }

        this.showDescript = true;
      }
    },
    changeSelect1(e) {
      console.log("111===", e);
      this.select1 = e;
      this.ranking();
    },
    changeSelect2(e) {
      this.select2 = e;
      this.tableData = this.getData[this.select2 - 1].list;
      if (this.tableData[0]) {
        let str = this.tableData[0].project.distance_num;
        this.distance_num = JSON.parse(str)[0];
      }
    },
    // 获取select数据
    startClass() {
      this.$api
        .gatallProject({
          plan_id: this.gameId,
          game_style: 1,
        })
        .then((res) => {
          if (res.status) {
            if (res.data && res.data.length > 0) {
              var arr = res.data;
              this.options1 = arr.map((r) => {
                return {
                  label: r.name,
                  value: r.ids,
                };
              });
              this.select1 = this.options1[0].value;
              this.ranking();
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
    // 根据select获取数据
    ranking() {
      this.loading = true;
      this.$api
        .getallRanking({
          ids: this.select1,
        })
        .then((res) => {
          if (res.status) {
            if (!res.data) {
              this.tableData = [];
            } else {
              this.getData = res.data;
              let length = res.data.length;
              this.options2 = [
                {
                  label: "总成绩",
                  value: 1,
                },
                {
                  label: "第一轮",
                  value: 2,
                },
                {
                  label: "第二轮",
                  value: 3,
                },
                {
                  label: "第三轮",
                  value: 4,
                },
                {
                  label: "第四轮",
                  value: 5,
                },
              ];
              this.options2 = this.options2.slice(0, length);
              this.select2 = this.options2[0].value;
              this.tableData = res.data[this.select2 - 1].list;
              if (this.tableData[0]) {
                let str = this.tableData[0].project.distance_num;
                this.distance_num = JSON.parse(str)[0];
              }
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .main {
    padding-top: 14px;

    .tabs {
      width: 100%;
      height: 80px;
      background: white;
      margin-bottom: 20px;
      padding: 14px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
    }
  }
}
.small_default_btn {
  display: inline-block;
  width: 42px !important;
  height: 24px !important;
  margin-right: 6px !important;
  margin-bottom: 6px !important;
  text-align: center;
  background: rgba(250, 250, 250, 1);
}
</style>
